import { getCookieByName as c } from "@ado/cookie-library";
const i = (o, e) => {
  document.cookie = o + "=" + encodeURI(e);
}, n = (o, e) => {
  const t = JSON.stringify(e);
  i(o, t);
}, s = (o, e) => {
  const t = c(o);
  return t ? JSON.parse(t) : e;
};
export {
  s as getJSONObjectFromCookie,
  i as setCookie,
  n as setCookieFromJSONObject
};
//# sourceMappingURL=index.js.map
